const AQ = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20744%20496'%3e%3cpath%20fill='%233A7DCE'%20d='M0,0h744v496H0V0z'/%3e%3cpolygon%20fill='%23ffffff'%20points='120,125%20210,188%20264,174%20287,93%20348,57%20440,71%20545,126%20551,216%20585,228%20585,320%20520,435%20442,459%20370,442%20388,412%20380,380%20370,389%20208,364%20159,279%20179,233%20130,171%20'/%3e%3c/svg%3e";
export {
  AQ as default
};
//# sourceMappingURL=AQ.svg.es.js.map
